import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { colors, spacing } from '../../style';
import { actionColor } from '../../style/theme-helpers';
import { Box } from '../box';

export const SELECT_OPTIONS_MAX_HEIGHT = 180;

const StyledSelect: any = styled(Box)`
  max-width: 100%;
  position: relative;
  font-size: 1rem;
  display: inline-block;
  cursor: pointer;

  ${props =>
    props.block &&
    css`
      width: 100%;
    `}
`;
const TogglingContainerWithRef = ({
  active,
  className,
  ...rest
}: {
  active?: boolean;
  disabled?: boolean;
  className: string;
}) => <div className={classNames('toggling-container', { disabled: rest.disabled, active }, className)} {...rest} />;

export const TogglingContainer = styled(TogglingContainerWithRef)`
  background-color: ${colors.white};
  border: 1px solid ${colors.gray300};
  position: relative;
  color: ${colors.gray900};
  border-radius: 4px;
  transition: all 250ms ease-out;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  padding-left: 8px;

  .label-icon {
    margin-right: ${spacing.xs};
  }

  .value-container {
    display: flex;
    width: 100%;
    align-items: center;
  }

  &:focus:not([disabled]):not(.disabled),
  &:active:not([disabled]):not(.disabled),
  &:focus-visible:not([disabled]):not(.disabled),
  &.active:not([disabled]):not(.disabled) {
    border: 1px solid ${actionColor};
  }

  &.disabled {
    background: ${colors.gray400};
    cursor: not-allowed;
  }
`;

const TogglingContainerLabel = styled.span`
  margin-right: auto;
  overflow: hidden;
`;

StyledSelect.displayName = 'StyledSelect';
TogglingContainer.displayName = 'TogglingContainer';
TogglingContainerLabel.displayName = 'TogglingContainerLabel';
StyledSelect.TogglingContainer = TogglingContainer;
StyledSelect.TogglingContainerLabel = TogglingContainerLabel;

export default StyledSelect;
